<template>
  <el-container class="partneri">
    <div style="text-align: center; max-width: 900px; padding-bottom: 20px">
      <h1>Partneři</h1>
    </div>
      <img src="partners/nsa_logo_rgb.svg" alt="nsa" height="150" style="padding-bottom: 20px;">
      <img src="partners/prazirna-kromeriz-logo.png" alt="prazirna-kromeriz" height="120" style="-webkit-filter: invert(1); filter: invert(1);">
  <img src="partners/prazirna-kromeriz-logo.png" alt="prazirna-kromeriz" height="120" style="-webkit-filter: invert(1); filter: invert(1);">
  <img src="partners/prazirna-kromeriz-logo.png" alt="prazirna-kromeriz" height="120" style="-webkit-filter: invert(1); filter: invert(1);">
<img src="partners/prazirna-kromeriz-logo.png" alt="prazirna-kromeriz" height="120" style="-webkit-filter: invert(1); filter: invert(1);">
  </el-container>
</template>

<script>

</script>


<style scoped>

.partneri {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  /* height: 600px; */
  width: 100%;
  /* background: rgb(219, 245, 255); */
  padding-bottom: 40px;
  padding-top: 40px;
}
</style>